import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-primary-500';
    if (trend === 'down') return 'ri-arrow-down-line text-foreground-400';
    return 'ri-subtract-line text-foreground-400';
  };

  return (
    <section id="ranking" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">热度排行</h2>
          <p className="text-sm text-foreground-500">实时追踪全网讨论热度，掌握吃瓜风向标</p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-xl overflow-hidden">
          {rankingItems.map((item, i) => (
            <a
              key={item.id}
              href="#ranking"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                i < rankingItems.length - 1 ? 'border-b border-background-100' : ''
              }`}
            >
              <span
                className={`w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold flex-shrink-0 whitespace-nowrap ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 3
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-400">{item.heat}</span>
                </div>
              </div>

              <div className="flex items-center gap-1 text-xs flex-shrink-0">
                <i className={getTrendIcon(item.trend)}></i>
                <span className={item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'}>
                  {item.change}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}